import { TQualifyData } from "../../components/modals/EditTrainingsModal";
import { TExam } from "../../shared/types/exam.type";
import { Fleet } from "../../shared/types/fleet.type";
import { THorse } from "../../shared/types/horse.type";
import { TRider } from "../../shared/types/rider.type";
import { TtrackCondition } from "../../shared/types/trackCondition.type";
import { Ttrack } from "../../shared/types/tracks.type";
import {
  TEquimetre,
  Ttraining,
  TTrainingType,
} from "../../shared/types/training.type";
import { TtrainingKeyParameterItem } from "../../shared/types/TrainingKeyParameterItem.type";
import { TShoeing } from "./../../shared/types/shoeing.type";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DisplayState = {
  trainingtypeModal: boolean;
  addPaymentMethodModal: boolean;
  shoeingModal: boolean;
  tracksLibraryModal: boolean;
  horseWeightModal: boolean;
  horseHeightModal: boolean;
  horseHrModal: boolean;
  horseModal: boolean;
  addVetModal: boolean;
  riderModal: boolean;
  tracksModal: boolean;
  trackNameModal: boolean;
  editTrainingModal: boolean;
  shareDataModal: boolean;
  blockLeaveEditTrainingModal: boolean;
  editTrainingsModal: boolean;
  sheoingItemToEdit: null | TShoeing;
  riderItemToEdit: null | TRider;
  trackItemToEdit: null | TtrackCondition;
  trackNameItemToEdit: null | Ttrack;
  trackNameToDuplicate: null | Ttrack;
  trainingToEdit: null | TExam;
  horseToEdit: null | THorse;
  editedExamQualifyData: null | TQualifyData;
  trainingTypeToEdit: null | TTrainingType;
  trainingsToEdit: number[];
  addVetModalExam?: number;
  horseHrExams: Ttraining[];
  editEqmNameModal: boolean;
  eqmToEdit: TEquimetre | null;
  eqmSubModal: boolean;
  eqmToSubscribe: TEquimetre |Fleet | null;
  isExamsEdited: boolean;
  dispatchReloadAnalytics: boolean;
  isPaymentMethodeAdded: boolean;
};

const initialState: DisplayState = {
  isExamsEdited: false,
  shoeingModal: false,
  horseHrModal: false,
  horseWeightModal: false,
  horseHeightModal: false,
  tracksLibraryModal: false,
  addVetModal: false,
  trainingtypeModal: false,
  trainingTypeToEdit: null,
  shareDataModal: false,
  horseModal: false,
  trackNameToDuplicate: null,
  sheoingItemToEdit: null,
  riderModal: false,
  riderItemToEdit: null,
  trackNameModal: false,
  tracksModal: false,
  editTrainingModal: false,
  blockLeaveEditTrainingModal: false,
  editTrainingsModal: false,
  trackItemToEdit: null,
  trackNameItemToEdit: null,
  trainingToEdit: null,
  horseToEdit: null,
  editedExamQualifyData: null,
  horseHrExams: [],
  trainingsToEdit: [],
  addVetModalExam: undefined,
  editEqmNameModal: false,
  eqmToEdit: null,
  eqmSubModal: false,
  eqmToSubscribe: null,
  addPaymentMethodModal: false,
  dispatchReloadAnalytics: false,
  isPaymentMethodeAdded: false,
};

export const modalReducer = createSlice({
  initialState,
  name: "modals",
  reducers: {
    setEqmSubscriptionModal: (state, action: PayloadAction<boolean>) => {
      state.eqmSubModal = action.payload;
    },
    setEqmSubscriptionItem: (
      state,
      action: PayloadAction<TEquimetre | Fleet | null>,
    ) => {
      state.eqmToSubscribe = action.payload;
    },
    setShoeingModal: (state, action: PayloadAction<boolean>) => {
      state.shoeingModal = action.payload;
    },
    setShoeingItemToEdit: (state, action: PayloadAction<TShoeing | null>) => {
      state.sheoingItemToEdit = action.payload;
    },
    setRiderModal: (state, action: PayloadAction<boolean>) => {
      state.riderModal = action.payload;
    },
    setRiderItemToEdit: (state, action: PayloadAction<TRider | null>) => {
      state.riderItemToEdit = action.payload;
    },
    setTrackModal: (state, action: PayloadAction<boolean>) => {
      state.tracksModal = action.payload;
    },
    setTrackItemToEdit: (
      state,
      action: PayloadAction<TtrackCondition | null>,
    ) => {
      state.trackItemToEdit = action.payload;
    },
    setTrackNameModal: (state, action: PayloadAction<boolean>) => {
      state.trackNameModal = action.payload;
    },
    setTrackNameItemToEdit: (state, action: PayloadAction<Ttrack | null>) => {
      state.trackNameItemToEdit = action.payload;
    },
    setTrackNameToDuplicate: (state, action: PayloadAction<Ttrack | null>) => {
      state.trackNameToDuplicate = action.payload;
    },
    setEditTrainingModal: (state, action: PayloadAction<boolean>) => {
      state.editTrainingModal = action.payload;
    },
    setHorseModal: (state, action: PayloadAction<boolean>) => {
      state.horseModal = action.payload;
    },
    setTrainingToEdit: (state, action: PayloadAction<TExam | null>) => {
      state.trainingToEdit = action.payload;
    },
    setHorseToEdit: (state, action: PayloadAction<THorse | null>) => {
      state.horseToEdit = action.payload;
    },
    setEditTrainingsModal: (state, action: PayloadAction<boolean>) => {
      state.editTrainingsModal = action.payload;
    },
    setTrainingTypeModal: (state, action: PayloadAction<boolean>) => {
      state.trainingtypeModal = action.payload;
    },
    setTrainingTypeToEdit: (
      state,
      action: PayloadAction<TTrainingType | null>,
    ) => {
      state.trainingTypeToEdit = action.payload;
    },
    setEditedExamQualifyData: (
      state,
      action: PayloadAction<TQualifyData | null>,
    ) => {
      state.editedExamQualifyData = action.payload;
    },
    setTrainingsToEdit: (state, action: PayloadAction<number[]>) => {
      state.trainingsToEdit = action.payload;
    },
    setBlockedEditModal: (state, action: PayloadAction<boolean>) => {
      state.blockLeaveEditTrainingModal = action.payload;
    },
    setAddVetModal: (state, action: PayloadAction<boolean>) => {
      state.addVetModal = action.payload;
    },
    setAddVetModalExam: (state, action: PayloadAction<number | undefined>) => {
      state.addVetModalExam = action.payload;
    },
    setTrackLibraryModal: (state, action: PayloadAction<boolean>) => {
      state.tracksLibraryModal = action.payload;
    },
    restModalsToInitialState: (state) => {
      return initialState;
    },
    setEditHorseWeightModal: (state, action: PayloadAction<boolean>) => {
      state.horseWeightModal = action.payload;
    },
    setEditHorseHeightModal: (state, action: PayloadAction<boolean>) => {
      state.horseHeightModal = action.payload;
    },
    setEditHorseHrModal: (state, action: PayloadAction<boolean>) => {
      state.horseHrModal = action.payload;
    },
    setHorseHrExams: (state, action: PayloadAction<Ttraining[]>) => {
      state.horseHrExams = action.payload;
    },
    setShareDataModal: (state, action: PayloadAction<boolean>) => {
      state.shareDataModal = action.payload;
    },
    setEqmNameModal: (state, action: PayloadAction<boolean>) => {
      state.editEqmNameModal = action.payload;
    },
    setAddPaymentMethodModal: (state, action: PayloadAction<boolean>) => {
      state.addPaymentMethodModal = action.payload;
    },
    setIsMethodeAdded: (state, action: PayloadAction<boolean>) => {
      state.isPaymentMethodeAdded = action.payload;
    },
    setEqmToEdit: (state, action: PayloadAction<TEquimetre | null>) => {
      state.eqmToEdit = action.payload;
    },
    setIsExamsEdited: (state, action: PayloadAction<boolean>) => {
      state.isExamsEdited = action.payload;
    },
    setReloadAnalytics: (state, action: PayloadAction<boolean>) => {
      state.dispatchReloadAnalytics = action.payload;
    },
  },
});

export const {
  setIsMethodeAdded,
  setReloadAnalytics,
  setIsExamsEdited,
  setAddPaymentMethodModal,
  setEqmSubscriptionModal,
  setEqmSubscriptionItem,
  setEqmNameModal,
  setEqmToEdit,
  setHorseHrExams,
  setEditHorseHrModal,
  setTrackNameToDuplicate,
  setShareDataModal,
  setEditHorseHeightModal,
  setEditHorseWeightModal,
  restModalsToInitialState,
  setAddVetModal,
  setBlockedEditModal,
  setShoeingModal,
  setShoeingItemToEdit,
  setRiderModal,
  setRiderItemToEdit,
  setTrackModal,
  setTrackItemToEdit,
  setTrackNameModal,
  setTrackNameItemToEdit,
  setEditTrainingModal,
  setTrainingToEdit,
  setHorseModal,
  setHorseToEdit,
  setEditTrainingsModal,
  setEditedExamQualifyData,
  setTrainingsToEdit,
  setTrainingTypeModal,
  setTrainingTypeToEdit,
  setAddVetModalExam,
  setTrackLibraryModal,
} = modalReducer.actions;
export default modalReducer.reducer;
